// components/FilterComponent.js
import React from 'react';

function Filter({ handleCityChange }) {
  return (
    <div>
      <label htmlFor="city-select">Şehir Seçin: </label>
      <select id="city-select" onChange={(e) => handleCityChange(e.target.value)}>
      <option value="All"></option>
        <option value="İstanbul">İstanbul</option>
        <option value="Ankara">Ankara</option>
        <option value="İzmir">İzmir</option>
        <option value="Bursa">Bursa</option>
      </select>
    </div>
  );
}

export default Filter;
